import PcLockr from './lockr' // 本地存储 用于localStorage存储
// import PcEncrypt from './encrypt' 前端加密  用于修改密码时加密
// import PcCookie from './cookie' cookie存储  用于未登录时购物车数据存储
// import Settings from '../util/settings' 以上三个文件的参数配置
var utils = {
    // 根据产品状态获取是否可加购
    getIfCanBuy: function(buyMark) {
        let arr = [1, 3, 5]
        if (!buyMark) {
            return true
        }
        return arr.includes(buyMark)
    },
    // 获取当前产品状态
    getbuyMarkTitle: function(buyMark) {
        let productStatusList =
            [
                {
                    dataValue: 1,
                    dataName: '在售'
                },
                {
                    dataValue: 2,
                    dataName: '售罄'
                },
                {
                    dataValue: 3,
                    dataName: '停产在售'
                },
                {
                    dataValue: 4,
                    dataName: '停产停售'
                },
                {
                    dataValue: 5,
                    dataName: '缺货'
                },
                {
                    dataValue: 6,
                    dataName: '缺货'
                }
            ]
        let one = productStatusList.filter(item => { return item.dataValue === buyMark })
        if (one.length > 0) {
            return one[0].dataName
        }
        return '在售'
    }
}

export {
    PcLockr,
    utils
}



// WEBPACK FOOTER //
// ./src/util/index.js